var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-edit',{on:{"edit":function($event){return _vm.$emit('edit')}}},[_c('order-contact',{attrs:{"order":_vm.$store.getters.orderSystem.order,"flat":"","divider":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }